import React, { useRef, useEffect } from "react";

interface OutsideAlertProps {
	children: React.ReactChild;
	outsideAlertCallback: Function;
	className?: string;
}
/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlert(ref: React.MutableRefObject<any>, outsideAlertCallback: Function) {
	useEffect(() => {
		// Call callback function if clicked outside of element
		function handleClickOutside(event: any) {
			if (ref.current && !ref.current.contains(event.target)) {
				outsideAlertCallback();
			}
		}

		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, outsideAlertCallback]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function OutsideAlert(props: OutsideAlertProps) {
	const wrapperRef = useRef(null);
	useOutsideAlert(wrapperRef, props.outsideAlertCallback);

	return <div ref={wrapperRef} className={props.className}>{props.children}</div>;
}